import { createReducer, Reducer } from "@reduxjs/toolkit";
import { merge } from "lodash";
import { RemoteResource } from "../common/fetchable";
import { Fetchable, EmptyFetchable } from "../common/fetchable/helpers";
import { LaunchConfigurationsDTO } from "../launch-configurations/models/dto";
import { LaunchesActions } from "./actions";
import { LaunchesDTO } from "./models/dto";

export namespace Launches {
  export const all: RemoteResource<
    LaunchesDTO.Responses.GetAll.T,
    LaunchesDTO.Responses.GetAll.T
  > = {
    fetch: LaunchesActions.getLaunches,
    updateStore: LaunchesActions.setLaunches,
    selector: (store) => store.launches.all,
  };
}

/**
 * Interface used for Redux Store
 */
export interface Launches {
  all: Fetchable<LaunchesDTO.Responses.GetAll.T>;
  configurations: Record<string, LaunchesDTO.Responses.GetSingle.T | "LOADING">;
  newParticipationForm: Record<
    LaunchConfigurationsDTO.Responses.GetSingle.T["id"],
    Partial<LaunchesDTO.Requests.ParticipationForm.ForForm>
  >; // Map of particpation form for each possible participation
}

const initialState: Launches = {
  all: EmptyFetchable,
  configurations: {},
  newParticipationForm: {},
};

// Reducer
export const launchesReducer: Reducer<
  Launches,
  LaunchesActions.Actions
> = createReducer(initialState, (builder) => {
  builder
    .addCase(LaunchesActions.getSingleLaunch, (state, action) => {
      state.configurations[action.payload] = "LOADING";
    })
    .addCase(LaunchesActions.setSingleLaunch, (state, action) => {
      state.configurations[action.payload.id] = action.payload.result;
    })
    .addCase(LaunchesActions.setLaunches, (state, action) => {
      state.all = action.payload;
    })
    .addCase(LaunchesActions.resetLaunches, (state) => {
      state.all = EmptyFetchable;
    })
    .addCase(
      LaunchesActions.setParticipationForm,
      (state, { payload: { id, data } }) => {
        state.newParticipationForm[id] = merge(
          state.newParticipationForm[id],
          data
        );
      }
    )
    .addCase(LaunchesActions.getLaunches, (state) => {
      state.all = {
        status: "loading",
      };
    });
});
